module.exports = __webpack_public_path__ + "static/media/warning-sign.a3e04152.svg";